
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"81","height":"80","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_5382_45561)"}},[_c('path',{attrs:{"d":"M40.5 0C18.433 0 .5 17.933.5 40s17.933 40 40 40 40-17.933 40-40-17.933-40-40-40zm-6.667 50c0 1.833-1.5 3.333-3.333 3.333A3.343 3.343 0 0127.167 50V30c0-1.833 1.5-3.333 3.333-3.333 1.833 0 3.333 1.5 3.333 3.333v20zm20 0c0 1.833-1.5 3.333-3.333 3.333A3.343 3.343 0 0147.167 50V30c0-1.833 1.5-3.333 3.333-3.333 1.833 0 3.333 1.5 3.333 3.333v20z","fill":"#00A351"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_5382_45561"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5)","d":"M0 0h80v80H0z"}})])])])
          )
        }
      }
    